<template>
  <exercise-logic
    exCollection="isinifExCollection"
    @ready="onReady"
    @error="onError"
    @saved="onSaved"
    @savedNext="onSavedNext"
    @loadedEx="onLoadedEx"
    @loadedRefs="onLoadedRefs"
    :doc="doc"
    :shared="false"
  >
    <template slot-scope="{ saveExercise }">
      <v-row>
        <v-col cols="4" class="mb-4">
          <h2 class="headline" v-text="$t('exercise_isinif.step1.title')"></h2>
        </v-col>
        <v-col cols="8" lg="6" class="mb-4">
          <p
            v-for="(item, index) in $t('exercise_isinif.step1.description')"
            :key="index"
            v-text="item"
          />
        </v-col>
      </v-row>
      <v-row v-if="doc">
        <v-col cols="4">
          <unit-items-top
            v-model="doc.is"
            :limit="5"
            name="col1"
            :num="$t('exercise_isinif.col1.top')"
            :title="$t('exercise_isinif.col1.title')"
            :description="$t('exercise_isinif.col1.description')"
            color="amber"
            bgColor="#303030"
            :reverse="false"
          >
          </unit-items-top>
        </v-col>
        <v-col cols="4">
          <unit-items-top
            v-model="doc.in"
            :limit="5"
            name="col1"
            :num="$t('exercise_isinif.col2.top')"
            :title="$t('exercise_isinif.col2.title')"
            :description="$t('exercise_isinif.col2.description')"
            color="amber"
            bgColor="#303030"
            :reverse="false"
          >
          </unit-items-top>
        </v-col>
        <v-col cols="4">
          <unit-items-top
            v-model="doc.if"
            :limit="5"
            name="col1"
            :num="$t('exercise_isinif.col3.top')"
            :title="$t('exercise_isinif.col3.title')"
            :description="$t('exercise_isinif.col3.description')"
            color="amber"
            bgColor="#303030"
            :reverse="false"
          >
          </unit-items-top>
        </v-col>
      </v-row>
      <bottom-navigation
        :save="true"
        :next="false"
        :prev="false"
        :gridView="false"
        :gridToggle="false"
        @save="saveExercise"
        @prev="prevStep"
        @next="saveExercise(false)"
      >
      </bottom-navigation>

      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title
            class="headline"
            v-text="$t('exercise_service.saved.title')"
          ></v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="amber" text @click="closeDialog">
              Close
            </v-btn>

            <v-btn
              color="amber accent-1"
              text
              :to="`/users/project/${$route.params.id}`"
            >
              Back to Project
            </v-btn>
            <v-btn color="amber accent-1" text to="/users/dashboard">
              Back to Dashboard
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </exercise-logic>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";
import { UnitItemsTop } from "@/components/units";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserIsInIf",
  data() {
    return {
      e1: 1,
      doc: {
        is: [],
        in: [],
        if: [],
      },
      tabs: [{ title: "IS IN IF", count: 1 }],
      userSelected: null,
      debug: false,
      dialog: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    UnitItemsTop,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
      // this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      // this.saveExercise(false);
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
      this.dialog = true;
    },
    onLoadedRefs(refs) {
      console.log("loaded", refs);
    },
    onLoadedEx(ex) {
      this.doc = ex.doc;
      this.exercise = ex;
    },
    onSavedNext() {
      this.nextStep();
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss"></style>
